import { put } from 'redux-saga/effects';

import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';

export function* getMedias(action) {
    try {
        const response = yield endpoint.get('medias/?company=DIGIMAIL&environment='+process.env.REACT_APP_CMS_ENV+'&language=sv', undefined, endpoint.API_URL.CMS);
        yield put({ type: types.SAGA_MEDIAS_GET.SUCCESS, payload: response.data.data });
    } catch (error) {
        yield put({ type: types.SAGA_MEDIAS_GET.FAILURE, error });
    }
}


// WEBPACK FOOTER //
// ./src/sagas/medias.js